// Gives the ability to set breadcrumbs and class name for the central layout
// Look into src/components/layout/layout.tsx for usage
// ==========================================================================

import { createContext } from "react";

export type BreadcrumbsItem = { href: string; label: string };

export const LayoutContext = createContext<{
  headerBreadcrumbs?: BreadcrumbsItem[];
  setHeaderBreadcrumbs: (breadcrumbs?: BreadcrumbsItem[]) => void;
  headerClassName?: string;
  setHeaderClassName: (headerClassName?: string) => void;
  mainClassName?: string;
  setMainClassName: (mainClassName?: string) => void;
}>({
  headerBreadcrumbs: undefined,
  setHeaderBreadcrumbs: () => {},
  headerClassName: undefined,
  setHeaderClassName: () => {},
  mainClassName: undefined,
  setMainClassName: () => {},
});
